// @ts-strict-ignore
import {
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { SohoBusyIndicatorDirective, SohoTrackDirtyDirective } from 'ids-enterprise-ng';
import { LMContextService, LMFormatUtilService, LMLoggerService } from '@app/services';
import { LMFormRequestService } from '@form/services';
import * as urltemplate from 'url-template';

@Component({
  selector: 'lm-application-menu-user-context-field',
  standalone: false,
  template: `
    <h4>{{ userContextField.label }}</h4>
    <br>
      <div class="row">
        <div class="four columns">
          <div class="field">
            <label [for]="userContextField.id" class="label">{{ actorContextLabel }}</label>
            <!--<input-->
            <!--soho-lookup [click]="onLookupClick"-->
            <!--soho-alert-->
            <!--soho-trackdirty-->
            <!--soho-busyindicator blockUI="true" displayDelay="0" [attr.id]="userContextField.id"-->
            <!--[(ngModel)]="value"/>-->
            @if (userContextField.value) {
              <select
                soho-dropdown noSearch [source]="source" [disabled]="userContextField.displayOnly"
                soho-busyindicator blockUI="true" displayDelay="0"
                soho-trackdirty (dirty)="onDirty($event)" (pristine)="onPristine($event)"
                (afterResetDirty)="onAfterResetDirty($event)"
                [attr.id]="id"
                (change)="onValueChanged()"
                [(ngModel)]="userContextField.value"
                >
                @for (item of states; track trackByValue($index, item)) {
                  <option
                    [value]="item.value">{{item.label}}&nbsp;
                  </option>
                }
              </select>
            }
            @if (!userContextField.value) {
              <label style="font-size: 14px;">{{ noValueText }}</label>
            }
          </div>
        </div>
        @if (userContextField.override) {
          <div class="four columns">
            <div class="field">
              <label [for]="overrideId" class="label">{{ URLOverrideLabel }}</label>
              <input [attr.id]="overrideId" soho-input disabled [(ngModel)]="userContextField.override">
            </div>
          </div>
        }
      </div>
      <div #dialogPlaceholder class="lmDialogPlaceholder"></div>
    `
})
export class LMApplicationMenuUserContextFieldComponent implements OnInit {
  @Input() userContextField: LMApplicationMenuUserContextField;
  @Output() contextValueChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() modelDirty: EventEmitter<{ dirty: boolean, field: LMApplicationMenuUserContextField }> = new EventEmitter<{ dirty: boolean, field: LMApplicationMenuUserContextField }>();
  @ViewChild(SohoBusyIndicatorDirective) busyIndicator: SohoBusyIndicatorDirective;
  @ViewChild(SohoTrackDirtyDirective) trackDirty: SohoTrackDirtyDirective;
  @ViewChild('dialogPlaceholder', { read: ViewContainerRef, static: true }) placeholder: ViewContainerRef;

  id: string;
  overrideId: string;
  states: Array<LMStateValue>;
  isDirty: boolean;
  modelFieldDirty: {
    dirty: boolean,
    field: LMApplicationMenuUserContextField
  };
  noValueText: string;
  URLOverrideLabel: string;
  actorContextLabel: string;

  // private fieldLookupDialog: SohoModalDialogRef<any>;
  // private lookupSelectionEvent: LMLookupSelectionEvent;
  // private lookupSelectionSubscription;

  constructor(
    private ngZone: NgZone,
    private lmFormatUtilService: LMFormatUtilService,
    private lmFormRequestService: LMFormRequestService,
    private lmLoggerService: LMLoggerService,
    private lmContextService: LMContextService
  ) {}

  ngOnInit() {
    this.noValueText = Soho.Locale.translate('ActorContextNoValueText');
    this.actorContextLabel = Soho.Locale.translate('ActorContextActorContextLabel');
    this.URLOverrideLabel = Soho.Locale.translate('ActorContextURLContextSessionKeyLabel');

    this.isDirty = false;

    this.modelFieldDirty = {
      dirty: false,
      field: this.userContextField
    };
    this.id = this.userContextField.contextPropertyId;
    this.overrideId = this.id + 'Override';

    this.states = [];
    this.states.push({
      value: this.userContextField.value,
      label: this.userContextField.value
    });

    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        if (this.trackDirty) {
          this.trackDirty.resetDirty();
        }
      }, 1);
    });

  }

  source = (response: any, searchTerm: any) => {
    this.busyIndicator.activated = true;

    const compiledFormRequestUrl = urltemplate.parse(this.userContextField.userDefinedStatesUrl);

    const dataView = {
      resourceId: this.userContextField.id,
      representativeText: '',
      status: '',
      name: '',
      action: '',
      busClassName: this.userContextField.id,
      navigations: [],
      contextProperties: null,
      actionMeta: null,
      fields: {}
    };

    // TODO: put this in service to be shared with lm-dropdown-soho
    this.lmFormRequestService
      .getUserDefinedStates(this.userContextField.userDefinedStatesUrl, this.userContextField.fieldId, dataView)
      .subscribe((result: LMUserDefinedResponse) => {
        let optionsAry;
        if (this.lmContextService.userDefinedStatesPageSizeAndIndicator) {
          if (result && result.hasOwnProperty('states') && Array.isArray(result.states)) {
            const zeroOrBlankValue = this.lmFormatUtilService.fieldStateFormatZeroValue(this.userContextField.type);
            optionsAry = this.lmFormatUtilService.fieldStatesToOptionsArray(result.states, true, zeroOrBlankValue);

            this.states = optionsAry;

            setTimeout(() => {
                // indicate to sohoxi dropdown to not create option tags
              response(optionsAry, true);
              this.busyIndicator.activated = false;
            }, 1);

            return;
          }
        } else {
          if (Array.isArray(result)) {
            const zeroOrBlankValue = this.lmFormatUtilService.fieldStateFormatZeroValue(this.userContextField.type);
            optionsAry = this.lmFormatUtilService.fieldStatesToOptionsArray(result, true, zeroOrBlankValue);

            this.states = optionsAry;

            setTimeout(() => {
                // indicate to sohoxi dropdown to not create option tags
              response(optionsAry, true);
              this.busyIndicator.activated = false;
            }, 1);

            return;
          }
        }

          // an error
        this.busyIndicator.activated = false;
        this.lmLoggerService.error([ 'Error in getUserDefinedStates', this.userContextField.id, result ]);
      },
      (error) => {
        this.busyIndicator.activated = false;
        this.lmLoggerService.error([ 'Error in getUserDefinedStates', this.userContextField.id, error ]);
      });
  };

  trackByValue(index: number, state: LMStateValue) {
    return state.value;
  }

  onValueChanged() {
    this.contextValueChanged.emit(this.userContextField);
  }

  onAfterResetDirty(event: SohoTrackDirtyEvent) {
    this.isDirty = false;
    this.modelFieldDirty.dirty = this.isDirty;
    this.modelFieldDirty.field = this.userContextField;

    this.modelDirty.emit(this.modelFieldDirty);
  }

  onDirty(event: SohoTrackDirtyEvent) {
    this.isDirty = true;
    this.modelFieldDirty.dirty = this.isDirty;
    this.modelFieldDirty.field = this.userContextField;

    this.modelDirty.emit(this.modelFieldDirty);
  }

  onPristine(event: SohoTrackDirtyEvent) {
    this.isDirty = false;
    this.modelFieldDirty.dirty = this.isDirty;
    this.modelFieldDirty.field = this.userContextField;

    this.modelDirty.emit(this.modelFieldDirty);
  }

  /**
   * Need this code for future implementation as these context fields are truly lookups
   * Currently having issues with xiharness with 3.5 content
   */
  // onLookupClick = (e, lookup) => {
  //   this.busyIndicator.activated = true;
  //
  //   const buttons: SohoModalButton[] = [
  //     {
  //       text: Soho.Locale.translate('Cancel'),
  //       // tslint:disable-next-line:no-shadowed-variable > shadowed variable e
  //       click: (e, modal) => {
  //         this.busyIndicator.activated = false;
  //         modal.close(true);
  //       }
  //     },
  //     {
  //       text: Soho.Locale.translate('Ok'),
  //       isDefault: true,
  //       // tslint:disable-next-line:no-shadowed-variable > shadowed variable e
  //       click: (e, modal) => {
  //         // this.handleSelection();
  //       }
  //     }
  //   ];
  //
  //   this.lmSpecService.getListSpec(this.userContextField.selectListUrl)
  //   .subscribe((listSpec: LMListSpec) => {
  //       this.fieldLookupDialog = this.sohoModalDialogService
  //       .modal(LMLookupDialogComponent, this.placeholder)
  //       .buttons(buttons)
  //       .title(listSpec.busListSpec.name)
  //       .isAlert(true)
  //       .open()
  //       .apply((lookupDialog: LMLookupDialogComponent) => {
  //         this.ngZone.run(() => {
  //           lookupDialog.listSpec = listSpec;
  //           lookupDialog.selectRequestData = {
  //             viewType: 'form',
  //             viewName: listSpec.busListSpec.name,
  //             dataView: {
  //               resourceId: this.userContextField.id,
  //               representativeText: '',
  //               status: '',
  //               name: '',
  //               action: '',
  //               busClassName: listSpec.busClassSpec.name,
  //               navigations: [],
  //               contextProperties: null,
  //               actionMeta: null,
  //               fields: {}
  //             },
  //           };
  //
  //           // ---------------------------------------------------------------------
  //           // need to markForCheck on the next tick() so angular picks up the
  //           // the list that is added to the dialog in this apply method.
  //           // ---------------------------------------------------------------------
  //           this.changeDetectionRef.markForCheck();
  //
  //           // need to listen for all occurrences as will get a row selection for a 'deselection'
  //           this.lookupSelectionSubscription =
  //             lookupDialog.lookupSelection.subscribe((event: LMLookupSelectionEvent) => {
  //               this.lookupSelectionEvent = event;
  //             });
  //
  //           lookupDialog.navigatingToolbarEvent.pipe(first()).subscribe(() => {
  //             this.fieldLookupDialog.close();
  //           });
  //         })
  //       })
  //       .afterClose(result => {
  //         this.busyIndicator.activated = false;
  //
  //         if (this.lookupSelectionSubscription) {
  //           this.lookupSelectionSubscription.unsubscribe();
  //           this.lookupSelectionSubscription = null;
  //         }
  //
  //         this.lookupSelectionEvent = null;
  //         this.fieldLookupDialog = null;
  //       });
  //     },
  //     (error: any) => {
  //       this.busyIndicator.activated = false;
  //       this.lmLoggerService.log([ 'LMLookupDialog error', error ]);
  //     });
  // }
  //
  // private handleSelection() {
  //   if (this.lookupSelectionEvent) {
  //     let result: Array<any> = this.lookupSelectionEvent.rows;
  //     if (result && Array.isArray(result) && result.length > 0) {
  //       let dataView: LMDataView = result[ 0 ].data;
  //       let fields = dataView.fields;
  //
  //       this.sohoLookup.setValue(this.lookupSelectionEvent.rows);
  //
  //       if (fields.hasOwnProperty(this.userContextField.id)) {
  //         this.value = fields[ this.userContextField.id ].value as string;
  //       }
  //     }
  //   }
  //
  //   this.fieldLookupDialog.close();
  // }
}
